'use client';

import { useEffect, useState } from "react";

// @ts-ignore
import ConvertKitForm from 'convertkit-react';

import { LayoutData } from "@/models/layout";

interface Props {
  data:  LayoutData
}

export default function Subscibe({ data }: Props) {
    const [emailConfig, setEmailConfig] = useState<{
        [key: string]: any;
    } | null>(null);

    const isDev = process.env.NODE_ENV === "development";

    useEffect(() => {
        setEmailConfig({
            formId: parseInt(data.footer.email_form_id),
            template: "clare",
            submitText: "I volunteer my inbox",
            buttonBackground: "#F7FF07",
            buttonColor: "#3E3E3D",
            hideName: true,
            namePlaceholder: "Name",
            emailPlaceholder: "Email",
        });
    }, [data.footer]);

    return (
        <>
            {emailConfig && (
                <>
                    <div className="text-3xl font-bold mb-8 text-center">
                        {data.footer.email_cta}
                    </div>
                    {!isDev && <ConvertKitForm {...emailConfig} />}
                </>
            )}
        </>
    );
}